import Card from "../../../components/UI/Card";
import {getTransactions, getCommissionBalanceInfo} from "../../../api/commissionTransaction";
import {Link} from "react-router-dom";
import Table from "../../../components/UI/Table";
import {createColumnHelper} from "@tanstack/react-table";
import CommissionTransactionFilter from "../../../views/commission-transactions/CommissionTransactionFilter";
import {useEffect, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import WithdrawRequestForm from "../../../views/commission-transactions/WithdrawRequestForm";
import AccountBalanceSummary from "../../../views/commission-transactions/AccountBalanceSummary";
import {checkPermission} from "../../../util/auth";
import {useNavigate} from "react-router";

const CommissionTransactions = () => {
  const columnHelper = createColumnHelper();
  const [commissionInfo, setCommissionInfo] = useState(null);
  const [openModal, setOpenModal] = useState(false)

  const navigate = useNavigate();
  useEffect(() => {
    if(!checkPermission(['TRANSACTIONS_VIEW'])){
      navigate("/no-access");
    }
  }, [navigate]);

  const {data} = useQuery({
    queryKey: ['commissionBalance'],
    queryFn: () => getCommissionBalanceInfo(),
    initialData: () => []
  })

  useEffect(() => {
    if (data !== undefined) {
      setCommissionInfo(data);
    }
  }, [data])

  const openWithdrawRequestModal = () =>{
    setOpenModal(true);
  }

  const columns = [
    columnHelper.display({
      id: "created_at",
      header: "Date",
      cell: props => <span> {props.row.original.created_at}</span>,
    }),
    columnHelper.display({
      id: "type",
      header: "Transaction Type",
      cell: props => <span className={`${props.row.original.type === 'commission' ? '' : 'text_red'} capitalized`} > {props.row.original.type}</span>,
    }),
    columnHelper.accessor('status',{
      id: "status",
      header: "Status",
      cell: props => <button className="btn btn_sm btn_black has_border_radius">{props.row.original.type === 'commission' ? 'Completed' : props.row.original.status}</button>,
    }),
    columnHelper.display({
      id: "order_number",
      header: "Order",
      cell: props =><> {checkPermission(['ORDER_READ']) ? <Link className={"text_underline"} to={`/orders/${props.row.original.order_id}`}>{props.row.original.order_number ? props.row.original.order_number : ''}</Link> : <a className="text_underline cursor_pointer">{props.row.original.order_number ? props.row.original.order_number : ''}</a> }</>,
    }),
    columnHelper.display({
      id: "sub_total",
      header: "Order Sub-total",
      cell: props => <span>{props.row.original.sub_total ? '$'+ props.row.original.sub_total.toFixed(2) : '-'}</span>,
    }),
    columnHelper.display({
      id: "amount",
      header: "Discount",
      cell: props => <span>{props.row.original.amount ? '$'+ props.row.original.amount.toFixed(2) : '-'}</span>,
    }),
    columnHelper.display({
      id: "commission_rate",
      header: "Commission Rate",
      cell: props => <span>{props.row.original.commission_rate ? props.row.original.commission_rate+'%' : '-'} </span>,
    }),
    columnHelper.display({
      id: "commission",
      header: "Commission",
      cell: props => <span> {props.row.original.commission ? '$'+props.row.original.commission.toFixed(2) : '-'} </span>,
    }),
    columnHelper.display({
      id: "vendor_balance",
      header: "Amount",
      cell: props => <span className={`${props.row.original.type === 'commission' ? '' : 'text_red'}`} >  ${props.row.original.vendor_balance ? props.row.original.vendor_balance.toFixed(2) : '0.00'}</span>,
    }),


  ];

  const [params, setParams] = useState({
    per_page: 20,
    page: 1,
    search: '',
    start_date: '',
    end_date: '',
    vendor_id: '',
  })

  return (
    <>
      <div className="row">
        <div className="col_9">
          <Card title={`${'Transaction History'}`}>
            <CommissionTransactionFilter params={params} setParams={setParams} />
            <Table queryKey={`transactions`}
                   columns={columns}
                   queryParams={params}
                   queryFn={getTransactions} />

          </Card>
        </div>
        <div className="col_3">
          <AccountBalanceSummary commissionInfo={commissionInfo} openWithdrawRequestModal={openWithdrawRequestModal} />
        </div>
      </div>

      <WithdrawRequestForm
          commissionInfo={commissionInfo}
          openModal={openModal}
          setOpenModal={setOpenModal}
      />
    </>
  );
}

export default CommissionTransactions